<template>
  <div class="grid-actions">
    <a href="" class="grid-actions__btn" @click.prevent="$parent.$parent.open(1, dat)">
      <i title="Modifiko" class="fa fa-pencil"></i>
    </a>
    <a href="" class="grid-actions__btn" @click.prevent="$parent.$parent.open(0, dat)">
      <i title="Shiko" class="fa fa-folder-open"></i>
    </a>
    <a v-if="dat.is_recipe == 1" href="" class="grid-actions__btn" @click.prevent="$parent.$parent.open(2, dat)">
      <i title="Shto materiale per kete produkt" class="fa fa-list"></i>
    </a>
  </div>
</template>
<script>
export default {
  name: "actions",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  watch: {
    data: {
      handler: function (val) {
        this.dat = val;
      },
      deep: true,
    },
  },
  setup(props) {
    return {
      dat: props.data,
    };
  },
};
</script>
<style scoped>
.grid-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0;
}

.grid-actions__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem;
  color: inherit;
  line-height: 1;
  font-size: 0.85rem;
}

.grid-actions__btn:hover {
  opacity: 0.75;
}
</style>
